import { ModuleFE_RuntimeSmartDoc } from './ModuleFE_RuntimeSmartDoc.js';
export const ModulePackFE_RuntimeSmartDocDB = [ModuleFE_RuntimeSmartDoc];
//# sourceMappingURL=module-pack.js.map